import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, User, ShieldCheck, Menu, X } from "lucide-react";
import { useStore } from "../context/StoreContext";
import { Button } from "./ui/button";

export default function Header() {
  const { bootstrap, user, cartCount, setCartOpen, logout } = useStore();
  const [menuOpen, setMenuOpen] = React.useState(false);
  const navigate = useNavigate();
  const categories = bootstrap?.categories || [];

  return (
    <header className="sticky top-0 z-40 bg-black/60 backdrop-blur-xl border-b border-white/10" data-testid="store-header">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-16 flex items-center justify-between gap-6">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-2.5 group">
          <img src="/assets/dragon-head.webp" alt="" className="h-10 w-auto drop-shadow-[0_0_12px_rgba(212,175,55,0.3)]" />
          <img src="/assets/wordmark.webp" alt="ZEFERIUS" className="h-7 w-auto hidden sm:block group-hover:opacity-90 transition-opacity" />
        </Link>

        <nav className="hidden md:flex items-center gap-8" data-testid="header-nav">
          <Link to="/" className="text-sm text-zinc-300 hover:text-gold transition-colors" data-testid="nav-home">Início</Link>
          {categories.map((c) => (
            <Link key={c.id} to={`/categoria/${c.slug}`} data-testid={`nav-cat-${c.slug}`}
              className="text-sm text-zinc-300 hover:text-gold transition-colors">
              {c.name}
            </Link>
          ))}
          <Link to="/autenticidade" className="text-sm text-zinc-300 hover:text-gold transition-colors flex items-center gap-1.5" data-testid="nav-authenticity">
            <ShieldCheck size={15} className="text-gold" /> Autenticidade
          </Link>
        </nav>

        <div className="flex items-center gap-2">
          {user ? (
            <div className="hidden md:flex items-center gap-2">
              {user.role === "admin" && (
                <Button variant="ghost" size="sm" data-testid="nav-admin-link" onClick={() => navigate("/admin")}
                  className="text-zinc-300 hover:text-gold hover:bg-amber-500/10">Admin</Button>
              )}
              <Button variant="ghost" size="sm" data-testid="nav-account" onClick={() => navigate("/conta")}
                className="text-zinc-300 hover:text-gold hover:bg-amber-500/10">
                <User size={15} className="mr-1.5" /> Conta
              </Button>
              <Button variant="ghost" size="sm" data-testid="nav-logout" onClick={logout}
                className="text-zinc-500 hover:text-gold hover:bg-amber-500/10">Sair</Button>
            </div>
          ) : (
            <Button variant="ghost" size="sm" data-testid="nav-login" onClick={() => navigate("/login")}
              className="hidden md:flex text-zinc-300 hover:text-gold hover:bg-amber-500/10">
              <User size={15} className="mr-1.5" /> Entrar
            </Button>
          )}
          <button
            data-testid="cart-open-button"
            onClick={() => setCartOpen(true)}
            className="relative p-2 text-zinc-200 hover:text-gold transition-colors"
            aria-label="Abrir carrinho"
          >
            <ShoppingBag size={20} />
            {cartCount > 0 && (
              <span data-testid="cart-count" className="absolute -top-0.5 -right-0.5 bg-gold text-black text-[10px] font-bold rounded-full w-4.5 h-4.5 min-w-[18px] min-h-[18px] flex items-center justify-center">
                {cartCount}
              </span>
            )}
          </button>
          <button className="md:hidden p-2 text-zinc-200" onClick={() => setMenuOpen(!menuOpen)} data-testid="mobile-menu-toggle" aria-label="Menu">
            {menuOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {menuOpen && (
        <nav className="md:hidden bg-[#0d0d0d] border-t border-white/10 px-6 py-4 flex flex-col gap-3" data-testid="mobile-menu">
          <Link to="/" onClick={() => setMenuOpen(false)} className="text-sm text-zinc-300 py-1" data-testid="mobile-nav-home">Início</Link>
          {categories.map((c) => (
            <Link key={c.id} to={`/categoria/${c.slug}`} onClick={() => setMenuOpen(false)} data-testid={`mobile-nav-cat-${c.slug}`}
              className="text-sm text-zinc-300 py-1">{c.name}</Link>
          ))}
          <Link to="/autenticidade" onClick={() => setMenuOpen(false)} className="text-sm text-gold py-1" data-testid="mobile-nav-authenticity">Autenticidade</Link>
          {user ? (
            <>
              <Link to="/conta" onClick={() => setMenuOpen(false)} className="text-sm text-zinc-300 py-1" data-testid="mobile-nav-account">Minha conta</Link>
              {user.role === "admin" && <Link to="/admin" onClick={() => setMenuOpen(false)} className="text-sm text-gold py-1" data-testid="mobile-nav-admin">Painel Admin</Link>}
            </>
          ) : (
            <Link to="/login" onClick={() => setMenuOpen(false)} className="text-sm text-zinc-300 py-1" data-testid="mobile-nav-login">Entrar</Link>
          )}
        </nav>
      )}
    </header>
  );
}
